const translations = {
	page_title: "Créer une souscription manuelle",
	title: "Créer une souscription manuelle",
	create_minimal_client_pm_title: "Créer une société minimale (Personne Morale)",
	create_minimal_client_pm_description: "La raison sociale suffit pour créer une souscription manuelle. La fiche société restera incomplète.",
	create_minimal_client_pp_title: "Créer un client minimal (Personne Physique)",
	create_minimal_client_pp_description: "Le nom et le prénom suffisent pour créer une souscription manuelle. La fiche client restera incomplète.",
	steps: {
		select_office: "Sélectionner un cabinet",
		select_cgp: "Sélectionner un CGP",
		select_client: "Sélectionner un client",
		create_client_pp: "Créer un client personne physique",
		create_client_pm: "Créer un client personne morale",
		ask_co_subscriber: "Co-souscription",
		create_co_subscriber_pp: "Créer un co-souscripteur",
		select_products: "Sélectionner les produits",
		create_minimal_client_pp: "Créer un client PP minimal",
		create_minimal_client_pm: "Créer un client PM minimal",
	},
	client_types: {
		individual: "Personne physique",
		corporation: "Personne morale",
	},
	create_client: {
		title: "Créer un client",
		button: "Créer un nouveau client",
		new_physical_person: "Nouvelle personne physique",
		new_corporation: "Nouvelle personne morale",
		new_minimal_corporation: "Nouvelle personne morale (minimal)",
		new_minimal_physical_person: "Nouvelle personne physique (minimal)",
	},
	create_corporation: {
		title: "Créer une personne morale",
	},
	modal_ask_co_subscriber: {
		title: "Co-souscription",
		text: "S'agit-il d'une co-souscription ?",
	},
};

export default translations;
